module.exports = __webpack_public_path__ + "img/stukalova.a700309e.jpg";